import { computed, shallowRef } from "vue";

export type DemoToolsScope = "global" | "assessment-hub" | "page";

const priority: Record<DemoToolsScope, number> = { global: 0, "assessment-hub": 1, page: 2 };
const launchers = shallowRef<{ id: symbol; scope: DemoToolsScope }[]>([]);

// A specific page supplies its own actions; the hub and layout supply fallbacks.
export const activeDemoToolsLauncher = computed(() => [...launchers.value].reverse().sort((a, b) => priority[b.scope] - priority[a.scope])[0]?.id);

export function registerDemoToolsLauncher(id: symbol, scope: DemoToolsScope): () => void {
    launchers.value = [...launchers.value, { id, scope }];
    return () => {
        launchers.value = launchers.value.filter((launcher) => launcher.id !== id);
    };
}
